module.exports = __webpack_public_path__ + "media/images/online/online-wedding-icon-homeparty-f9c8bc30029f6938c356b30e940d9681.png";